import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
    statCard: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    statValue: {
        fontWeight: 'bold',
        fontSize: '1.8rem',
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(1),
    },
    statLabel: {
        fontSize: '0.9rem',
    },
    sectionTitle: {
        marginBottom: theme.spacing(2),
        fontWeight: 500,
    },
}));

function BillingStats({ summary, showDQW = false }) {
    const classes = useStyles();

    if (!summary) {
        return null;
    }

    return (
        <div>
            <Typography variant="h6" className={classes.sectionTitle}>Billing Summary</Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <Paper className={classes.statCard} elevation={2}>
                        <Typography className={classes.statValue}>
                            {summary.total_insiders_with_orgs}
                        </Typography>
                        <Typography className={classes.statLabel}>
                            Total Insiders with Organizations
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Paper className={classes.statCard} elevation={2}>
                        <Typography className={classes.statValue}>
                            {summary.insiders_with_billing_data}
                        </Typography>
                        <Typography className={classes.statLabel}>
                            Insiders with Billing Data
                        </Typography>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Paper className={classes.statCard} elevation={2}>
                        <Typography className={classes.statValue}>
                            {summary.total_organizations_processed}
                        </Typography>
                        <Typography className={classes.statLabel}>
                            Total Organizations Processed
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
}

export default BillingStats;
